import { render } from "./Historique.vue?vue&type=template&id=44f5ecda"
import script from "./Historique.vue?vue&type=script&lang=js"
export * from "./Historique.vue?vue&type=script&lang=js"

import "./Historique.vue?vue&type=style&index=0&id=44f5ecda&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__